import { BackendResponse } from "../BackendResponse";
import { withNextApi } from "../nextApiHelpers";

export interface EmailVerificationForCandidateResponse extends BackendResponse {
  item: CvpEmailPhoneStatus;
  candidatePendingEmail: string;
  idVerify: number;
  skippedCrossConcernCheckInDevmode: boolean;
}

export const checkEmailVerification =
  withNextApi<EmailVerificationForCandidateResponse>(
    "/cvp/CvpCheckEmailVerification"
  );

export enum CvpEmailPhoneStatus {
  Verified,
  NotVerified,
  VerificationPending,
  VerificationExpired, // not used
  ChangePending,
}

// public enum CvpEmailPhoneStatus {
//   Verified,
//   NotVerified,
//   VerificationPending,
//   VerificationExpired, // not used, use NotVerified
//   ChangePending,
// }
